import request, { apiRequest } from '../../apiCall'
import { getRequestRequirement } from '../../requestConfig';

class PackageService {


    async useGetUserPackages(params) {

        const requirement = getRequestRequirement('Package.GetPackagesByUserId');
        try {

            const response = await request[requirement.action.method](`${requirement.path}`, params.params);
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }

    async getPackages(params) {
        try {
            const response = await apiRequest("Package.GetPackagesType",
                { ...params.params }, `?Currency=${params.params.currency}`);
            return response
        } catch (error) {
            throw error
        }


    }


    async postActivePackage(params) {
        try {
            const response = await apiRequest("Package.AddPackageForUser",
                { ...params.params }, `?Currency=${params.params.Currency}`);
            return response
        } catch (error) {
            throw error
        }


    }

    async getInvoiceDetail(invoiceId) {
        try {
            const response = await apiRequest("WhmcsProduct.InvoiceDetail",
                {}, `?invoiceId=${invoiceId}`);
            return response
        } catch (error) {
            throw error
        }


    }



    async getUpgradablePackagesService(params) {
        try {
            const response = await apiRequest("Package.GetUpgradablePackages",
                {}, `?userId=${params.userId}&Currency=${params.currency}`);
            return response
        } catch (error) {
            throw error
        }


    }


    async upgradablePackagesService(params) {
        try {
            const response = await apiRequest("APIRunner.TestApiRunner",
                { ...params },);
            return response
        } catch (error) {
            throw error
        }


    }
}

export default new PackageService();